import { render } from "./PublicationsList.vue?vue&type=template&id=80a3d486"
import script from "./PublicationsList.vue?vue&type=script&lang=js"
export * from "./PublicationsList.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__